import React, { Component } from 'react';
import PropTypes from "prop-types";
import { inject, observer } from 'mobx-react';
import { AppStore, MapStore } from "@/store/";

import "./index.scoped.sass";

// todo  passive：true  ios bug ?
// https://www.jianshu.com/p/bf4b3693a4f1

@inject(stores => ({
    appStore: stores.appStore,
    mapStore: stores.mapStore,
}))
@observer
class ILoc extends Component {
    constructor(props) {
        super(props);
        this.longPressTimer = -1;
    }

    touchstart = (event) => {
        event.persist();
        event.stopPropagation();
        event.preventDefault();
        this.longPressTimer = setTimeout(this.longPress, 500);
    }

    touchmove = (event) => {
        event.persist();
        event.stopPropagation();
        event.preventDefault();
        clearTimeout(this.longPressTimer);
    }
    touchend = (event) => {
        event.persist();
        event.stopPropagation();
        event.preventDefault();
        //单击
        clearTimeout(this.longPressTimer);
        if (this.longPressTimer != 0) {
            this.props.mapStore.mapPanToMyLoc();
        }
    }
    longPress = () => {
        // 长按执行后吧 longPressTimer 置为0 这时候松开手会执行 touchend ，判断到 0 就不执行单击事件 从而长按只执行 长按事件
        this.longPressTimer = 0;
        this.props.appStore.changeWatchLoc();
    }

    render() {
        return (
            <div id="iLoc" mdui-tooltip="{position:'right',content:'长按监听定位'}" onClick={this.touchend} onTouchStart={this.touchstart} onTouchMove={this.touchmove} onTouchEnd={this.touchend}>
                {
                    this.props.watchLoc ?
                        <div className="icon iconfont icon-position watch"></div> :
                        this.props.isLocIng ?
                            <div className="icon loading"></div> :
                            this.props.locState ?
                                <div className={"icon iconfont icon-position succ"}></div> :
                                <div className={"icon iconfont icon-position error"}></div>

                }
            </div>
        );
    }
}

ILoc.propTypes = {
    isLocIng: PropTypes.bool.isRequired,
    locState: PropTypes.bool.isRequired,
    watchLoc: PropTypes.bool.isRequired,
};

ILoc.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    mapStore: PropTypes.instanceOf(MapStore).isRequired,
};

export default ILoc;